var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../../../../../../Users/ffedel/AppData/Roaming/nvm/v10.24.1/node_modules/front-cli/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":0,\"remove\":true,\"publicPath\":\"../\"}!css-loader?{\"sourceMap\":true,\"minimize\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5d1895a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./footer.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader?{\"presets\":[[\"C:\\\\Users\\\\ffedel\\\\AppData\\\\Roaming\\\\nvm\\\\v10.24.1\\\\node_modules\\\\front-cli\\\\node_modules\\\\babel-preset-env\\\\lib\\\\index.js\",{\"targets\":{\"browsers\":[\"ie >= 11\"]},\"modules\":false,\"useBuiltIns\":true,\"debug\":false}]],\"plugins\":[\"syntax-dynamic-import\"]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./footer.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5d1895a8\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./footer.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d1895a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "application\\views\\commons\\footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5d1895a8", Component.options)
  } else {
    hotAPI.reload("data-v-5d1895a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./application/views/commons/footer.vue
// module id = 258
// module chunks = 3